export const countries = [
    {
        "name": "Andorra",
        "iso": {
            "alpha-2": "AD",
            "alpha-3": "AND",
            "numeric": "020"
        },
        "phone": "+376",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg",
        "phoneLength": 6
    },
    {
        "name": "United Arab Emirates",
        "iso": {
            "alpha-2": "AE",
            "alpha-3": "ARE",
            "numeric": "784"
        },
        "phone": "+971",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg",
        "phoneLength": 9
    },
    {
        "name": "Afghanistan",
        "iso": {
            "alpha-2": "AF",
            "alpha-3": "AFG",
            "numeric": "004"
        },
        "phone": "+93",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg",
        "phoneLength": 9
    },
    {
        "name": "Antigua and Barbuda",
        "iso": {
            "alpha-2": "AG",
            "alpha-3": "ATG",
            "numeric": "028"
        },
        "phone": "+1-268",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg",
        "phoneLength": 10
    },
    {
        "name": "Anguilla",
        "iso": {
            "alpha-2": "AI",
            "alpha-3": "AIA",
            "numeric": "660"
        },
        "phone": "+1-264",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg",
        "phoneLength": 10
    },
    {
        "name": "Albania",
        "iso": {
            "alpha-2": "AL",
            "alpha-3": "ALB",
            "numeric": "008"
        },
        "phone": "+355",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg",
        "phoneLength": 9
    },
    {
        "name": "Armenia",
        "iso": {
            "alpha-2": "AM",
            "alpha-3": "ARM",
            "numeric": "051"
        },
        "phone": "+374",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg",
        "phoneLength": 6
    },
    {
        "name": "Angola",
        "iso": {
            "alpha-2": "AO",
            "alpha-3": "AGO",
            "numeric": "024"
        },
        "phone": "+244",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg",
        "phoneLength": 9
    },
    {
        "name": "Antarctica",
        "iso": {
            "alpha-2": "AQ",
            "alpha-3": "ATA",
            "numeric": "010"
        },
        "phone": "+672",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg",
        "phoneLength": 6
    },
    {
        "name": "Argentina",
        "iso": {
            "alpha-2": "AR",
            "alpha-3": "ARG",
            "numeric": "032"
        },
        "phone": "+54",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg",
        "phoneLength": [
            6,
            7,
            8
        ]
    },
    {
        "name": "American Samoa",
        "iso": {
            "alpha-2": "AS",
            "alpha-3": "ASM",
            "numeric": "016"
        },
        "phone": "+1-684",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg",
        "phoneLength": 10
    },
    {
        "name": "Austria",
        "iso": {
            "alpha-2": "AT",
            "alpha-3": "AUT",
            "numeric": "040"
        },
        "phone": "+43",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
        "phoneLength": [
            10,
            11
        ]
    },
    {
        "name": "Australia",
        "iso": {
            "alpha-2": "AU",
            "alpha-3": "AUS",
            "numeric": "036"
        },
        "phone": "+61",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
        "phoneLength": 9
    },
    {
        "name": "Aruba",
        "iso": {
            "alpha-2": "AW",
            "alpha-3": "ABW",
            "numeric": "533"
        },
        "phone": "+297",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg",
        "phoneLength": 7
    },
    {
        "name": "\u00c5land Islands",
        "iso": {
            "alpha-2": "AX",
            "alpha-3": "ALA",
            "numeric": "248"
        },
        "phone": "+358-18",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg"
    },
    {
        "name": "Azerbaijan",
        "iso": {
            "alpha-2": "AZ",
            "alpha-3": "AZE",
            "numeric": "031"
        },
        "phone": "+994",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg",
        "phoneLength": 9
    },
    {
        "name": "Bosnia and Herzegovina",
        "iso": {
            "alpha-2": "BA",
            "alpha-3": "BIH",
            "numeric": "070"
        },
        "phone": "+387",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg",
        "phoneLength": 8
    },
    {
        "name": "Barbados",
        "iso": {
            "alpha-2": "BB",
            "alpha-3": "BRB",
            "numeric": "052"
        },
        "phone": "+1-246",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg",
        "phoneLength": 10
    },
    {
        "name": "Bangladesh",
        "iso": {
            "alpha-2": "BD",
            "alpha-3": "BGD",
            "numeric": "050"
        },
        "phone": "+880",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg",
        "phoneLength": 10
    },
    {
        "name": "Belgium",
        "iso": {
            "alpha-2": "BE",
            "alpha-3": "BEL",
            "numeric": "056"
        },
        "phone": "+32",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg",
        "phoneLength": 9
    },
    {
        "name": "Burkina Faso",
        "iso": {
            "alpha-2": "BF",
            "alpha-3": "BFA",
            "numeric": "854"
        },
        "phone": "+226",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg",
        "phoneLength": 8
    },
    {
        "name": "Bulgaria",
        "iso": {
            "alpha-2": "BG",
            "alpha-3": "BGR",
            "numeric": "100"
        },
        "phone": "+359",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg",
        "phoneLength": 9
    },
    {
        "name": "Bahrain",
        "iso": {
            "alpha-2": "BH",
            "alpha-3": "BHR",
            "numeric": "048"
        },
        "phone": "+973",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg",
        "phoneLength": 8
    },
    {
        "name": "Burundi",
        "iso": {
            "alpha-2": "BI",
            "alpha-3": "BDI",
            "numeric": "108"
        },
        "phone": "+257",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg",
        "phoneLength": 8
    },
    {
        "name": "Benin",
        "iso": {
            "alpha-2": "BJ",
            "alpha-3": "BEN",
            "numeric": "204"
        },
        "phone": "+229",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg",
        "phoneLength": 8
    },
    {
        "name": "Saint Barth\u00e9lemy",
        "iso": {
            "alpha-2": "BL",
            "alpha-3": "BLM",
            "numeric": "652"
        },
        "phone": "+590",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg",
        "phoneLength": 9
    },
    {
        "name": "Bermuda",
        "iso": {
            "alpha-2": "BM",
            "alpha-3": "BMU",
            "numeric": "060"
        },
        "phone": "+1-441",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg",
        "phoneLength": 10
    },
    {
        "name": "Brunei Darussalam",
        "iso": {
            "alpha-2": "BN",
            "alpha-3": "BRN",
            "numeric": "096"
        },
        "phone": "+673",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg",
        "phoneLength": 7
    },
    {
        "name": "Bolivia, Plurinational State of",
        "iso": {
            "alpha-2": "BO",
            "alpha-3": "BOL",
            "numeric": "068"
        },
        "phone": "+591",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg",
        "phoneLength": 9
    },
    {
        "name": "Brazil",
        "iso": {
            "alpha-2": "BR",
            "alpha-3": "BRA",
            "numeric": "076"
        },
        "phone": "+55",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg",
        "phoneLength": 11
    },
    {
        "name": "Bahamas",
        "iso": {
            "alpha-2": "BS",
            "alpha-3": "BHS",
            "numeric": "044"
        },
        "phone": "+1-242",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg",
        "phoneLength": 10
    },
    {
        "name": "Bhutan",
        "iso": {
            "alpha-2": "BT",
            "alpha-3": "BTN",
            "numeric": "064"
        },
        "phone": "+975",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg",
        "phoneLength": 7
    },
    {
        "phoneLength": 10
    },
    {
        "name": "Botswana",
        "iso": {
            "alpha-2": "BW",
            "alpha-3": "BWA",
            "numeric": "072"
        },
        "phone": "+267",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg",
        "phoneLength": 7
    },
    {
        "name": "Belarus",
        "iso": {
            "alpha-2": "BY",
            "alpha-3": "BLR",
            "numeric": "112"
        },
        "phone": "+375",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg",
        "phoneLength": 9
    },
    {
        "name": "Belize",
        "iso": {
            "alpha-2": "BZ",
            "alpha-3": "BLZ",
            "numeric": "084"
        },
        "phone": "+501",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg",
        "phoneLength": 7
    },
    {
        "name": "Canada",
        "iso": {
            "alpha-2": "CA",
            "alpha-3": "CAN",
            "numeric": "124"
        },
        "phone": "+1",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg",
        "phoneLength": 10
    },
    {
        "name": "Cocos (Keeling) Islands",
        "iso": {
            "alpha-2": "CC",
            "alpha-3": "CCK",
            "numeric": "166"
        },
        "phone": "+61",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg",
        "phoneLength": 10
    },
    {
        "name": "Congo, the Democratic Republic of the",
        "iso": {
            "alpha-2": "CD",
            "alpha-3": "COD",
            "numeric": "180"
        },
        "phone": "+243",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg",
        "phoneLength": 7
    },
    {
        "name": "Central African Republic",
        "iso": {
            "alpha-2": "CF",
            "alpha-3": "CAF",
            "numeric": "140"
        },
        "phone": "+236",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg",
        "phoneLength": 8
    },
    {
        "name": "Congo",
        "iso": {
            "alpha-2": "CG",
            "alpha-3": "COG",
            "numeric": "178"
        },
        "phone": "+242",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg",
        "phoneLength": 9
    },
    {
        "name": "Switzerland",
        "iso": {
            "alpha-2": "CH",
            "alpha-3": "CHE",
            "numeric": "756"
        },
        "phone": "+41",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
        "phoneLength": 9
    },
    {
        "name": "C\u00f4te d'Ivoire",
        "iso": {
            "alpha-2": "CI",
            "alpha-3": "CIV",
            "numeric": "384"
        },
        "phone": "+225",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg",
        "phoneLength": 8
    },
    {
        "name": "Cook Islands",
        "iso": {
            "alpha-2": "CK",
            "alpha-3": "COK",
            "numeric": "184"
        },
        "phone": "+682",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg",
        "phoneLength": 5
    },
    {
        "name": "Chile",
        "iso": {
            "alpha-2": "CL",
            "alpha-3": "CHL",
            "numeric": "152"
        },
        "phone": "+56",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg",
        "phoneLength": 9
    },
    {
        "name": "Cameroon",
        "iso": {
            "alpha-2": "CM",
            "alpha-3": "CMR",
            "numeric": "120"
        },
        "phone": "+237",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg",
        "phoneLength": 9
    },
    {
        "name": "China",
        "iso": {
            "alpha-2": "CN",
            "alpha-3": "CHN",
            "numeric": "156"
        },
        "phone": "+86",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg",
        "phoneLength": 11
    },
    {
        "name": "Colombia",
        "iso": {
            "alpha-2": "CO",
            "alpha-3": "COL",
            "numeric": "170"
        },
        "phone": "+57",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg",
        "phoneLength": 10
    },
    {
        "name": "Costa Rica",
        "iso": {
            "alpha-2": "CR",
            "alpha-3": "CRI",
            "numeric": "188"
        },
        "phone": "+506",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg",
        "phoneLength": 8
    },
    {
        "name": "Cuba",
        "iso": {
            "alpha-2": "CU",
            "alpha-3": "CUB",
            "numeric": "192"
        },
        "phone": "+53",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg",
        "phoneLength": 8
    },
    {
        "name": "Cape Verde",
        "iso": {
            "alpha-2": "CV",
            "alpha-3": "CPV",
            "numeric": "132"
        },
        "phone": "+238",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg",
        "phoneLength": 7
    },
    {
        "name": "Cura\u00e7ao",
        "iso": {
            "alpha-2": "CW",
            "alpha-3": "CUW",
            "numeric": "531"
        },
        "phone": "+599",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CW.svg",
        "phoneLength": 7
    },
    {
        "name": "Christmas Island",
        "iso": {
            "alpha-2": "CX",
            "alpha-3": "CXR",
            "numeric": "162"
        },
        "phone": "+61",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg",
        "phoneLength": 9
    },
    {
        "name": "Cyprus",
        "iso": {
            "alpha-2": "CY",
            "alpha-3": "CYP",
            "numeric": "196"
        },
        "phone": "+357",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg",
        "phoneLength": 8
    },
    {
        "name": "Czech Republic",
        "iso": {
            "alpha-2": "CZ",
            "alpha-3": "CZE",
            "numeric": "203"
        },
        "phone": "+420",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg",
        "phoneLength": 9
    },
    {
        "name": "Germany",
        "iso": {
            "alpha-2": "DE",
            "alpha-3": "DEU",
            "numeric": "276"
        },
        "phone": "+49",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
        "phoneLength": 10
    },
    {
        "name": "Djibouti",
        "iso": {
            "alpha-2": "DJ",
            "alpha-3": "DJI",
            "numeric": "262"
        },
        "phone": "+253",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg",
        "phoneLength": 10
    },
    {
        "name": "Denmark",
        "iso": {
            "alpha-2": "DK",
            "alpha-3": "DNK",
            "numeric": "208"
        },
        "phone": "+45",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg",
        "phoneLength": 8
    },
    {
        "name": "Dominica",
        "iso": {
            "alpha-2": "DM",
            "alpha-3": "DMA",
            "numeric": "212"
        },
        "phone": "+1-767",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg",
        "phoneLength": 10
    },
    {
        "name": "Dominican Republic",
        "iso": {
            "alpha-2": "DO",
            "alpha-3": "DOM",
            "numeric": "214"
        },
        "phone": "+1-809",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg",
        "phoneLength": 10
    },
    {
        "name": "Algeria",
        "iso": {
            "alpha-2": "DZ",
            "alpha-3": "DZA",
            "numeric": "012"
        },
        "phone": "+213",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg",
        "phoneLength": 9
    },
    {
        "name": "Ecuador",
        "iso": {
            "alpha-2": "EC",
            "alpha-3": "ECU",
            "numeric": "218"
        },
        "phone": "+593",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg",
        "phoneLength": 9
    },
    {
        "name": "Estonia",
        "iso": {
            "alpha-2": "EE",
            "alpha-3": "EST",
            "numeric": "233"
        },
        "phone": "+372",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg",
        "phoneLength": 8
    },
    {
        "name": "Egypt",
        "iso": {
            "alpha-2": "EG",
            "alpha-3": "EGY",
            "numeric": "818"
        },
        "phone": "+20",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg",
        "phoneLength": 10
    },
    {
        "phoneLength": 9
    },
    {
        "name": "Eritrea",
        "iso": {
            "alpha-2": "ER",
            "alpha-3": "ERI",
            "numeric": "232"
        },
        "phone": "+291",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg",
        "phoneLength": 7
    },
    {
        "name": "Spain",
        "iso": {
            "alpha-2": "ES",
            "alpha-3": "ESP",
            "numeric": "724"
        },
        "phone": "+34",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg",
        "phoneLength": 9
    },
    {
        "name": "Ethiopia",
        "iso": {
            "alpha-2": "ET",
            "alpha-3": "ETH",
            "numeric": "231"
        },
        "phone": "+251",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg",
        "phoneLength": 9
    },
    {
        "name": "Finland",
        "iso": {
            "alpha-2": "FI",
            "alpha-3": "FIN",
            "numeric": "246"
        },
        "phone": "+358",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg"
    },
    {
        "name": "Fiji",
        "iso": {
            "alpha-2": "FJ",
            "alpha-3": "FJI",
            "numeric": "242"
        },
        "phone": "+679",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg",
        "phoneLength": 7
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "iso": {
            "alpha-2": "FK",
            "alpha-3": "FLK",
            "numeric": "238"
        },
        "phone": "+500",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg",
        "phoneLength": 5
    },
    {
        "name": "Micronesia, Federated States of",
        "iso": {
            "alpha-2": "FM",
            "alpha-3": "FSM",
            "numeric": "583"
        },
        "phone": "+691",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg",
        "phoneLength": 7
    },
    {
        "name": "Faroe Islands",
        "iso": {
            "alpha-2": "FO",
            "alpha-3": "FRO",
            "numeric": "234"
        },
        "phone": "+298",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg",
        "phoneLength": 5
    },
    {
        "name": "France",
        "iso": {
            "alpha-2": "FR",
            "alpha-3": "FRA",
            "numeric": "250"
        },
        "phone": "+33",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg",
        "phoneLength": 9
    },
    {
        "name": "Gabon",
        "iso": {
            "alpha-2": "GA",
            "alpha-3": "GAB",
            "numeric": "266"
        },
        "phone": "+241",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg",
        "phoneLength": 7
    },
    {
        "name": "United Kingdom",
        "iso": {
            "alpha-2": "GB",
            "alpha-3": "GBR",
            "numeric": "826"
        },
        "phone": "+44",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg",
        "phoneLength": 10
    },
    {
        "name": "Grenada",
        "iso": {
            "alpha-2": "GD",
            "alpha-3": "GRD",
            "numeric": "308"
        },
        "phone": "+1-473",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg",
        "phoneLength": 10
    },
    {
        "name": "Georgia",
        "iso": {
            "alpha-2": "GE",
            "alpha-3": "GEO",
            "numeric": "268"
        },
        "phone": "+995",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg",
        "phoneLength": 9
    },
    {
        "name": "French Guiana",
        "iso": {
            "alpha-2": "GF",
            "alpha-3": "GUF",
            "numeric": "254"
        },
        "phone": "+594",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg",
        "phoneLength": 9
    },
    {
        "name": "Guernsey",
        "iso": {
            "alpha-2": "GG",
            "alpha-3": "GGY",
            "numeric": "831"
        },
        "phone": "+44-1481",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg",
        "phoneLength": 10
    },
    {
        "name": "Ghana",
        "iso": {
            "alpha-2": "GH",
            "alpha-3": "GHA",
            "numeric": "288"
        },
        "phone": "+233",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg",
        "phoneLength": 9
    },
    {
        "name": "Gibraltar",
        "iso": {
            "alpha-2": "GI",
            "alpha-3": "GIB",
            "numeric": "292"
        },
        "phone": "+350",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg",
        "phoneLength": 8
    },
    {
        "name": "Greenland",
        "iso": {
            "alpha-2": "GL",
            "alpha-3": "GRL",
            "numeric": "304"
        },
        "phone": "+299",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg",
        "phoneLength": 6
    },
    {
        "name": "Gambia",
        "iso": {
            "alpha-2": "GM",
            "alpha-3": "GMB",
            "numeric": "270"
        },
        "phone": "+220",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg",
        "phoneLength": 7
    },
    {
        "name": "Guinea",
        "iso": {
            "alpha-2": "GN",
            "alpha-3": "GIN",
            "numeric": "324"
        },
        "phone": "+224",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg",
        "phoneLength": 9
    },
    {
        "name": "Guadeloupe",
        "iso": {
            "alpha-2": "GP",
            "alpha-3": "GLP",
            "numeric": "312"
        },
        "phone": "+590",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg",
        "phoneLength": 9
    },
    {
        "name": "Equatorial Guinea",
        "iso": {
            "alpha-2": "GQ",
            "alpha-3": "GNQ",
            "numeric": "226"
        },
        "phone": "+240",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg",
        "phoneLength": 9
    },
    {
        "name": "Greece",
        "iso": {
            "alpha-2": "GR",
            "alpha-3": "GRC",
            "numeric": "300"
        },
        "phone": "+30",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg",
        "phoneLength": 10
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "iso": {
            "alpha-2": "GS",
            "alpha-3": "SGS",
            "numeric": "239"
        },
        "phone": "+",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg",
        "phoneLength": 5
    },
    {
        "name": "Guatemala",
        "iso": {
            "alpha-2": "GT",
            "alpha-3": "GTM",
            "numeric": "320"
        },
        "phone": "+502",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg",
        "phoneLength": 8
    },
    {
        "name": "Guam",
        "iso": {
            "alpha-2": "GU",
            "alpha-3": "GUM",
            "numeric": "316"
        },
        "phone": "+1-671",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg",
        "phoneLength": 10
    },
    {
        "name": "Guinea-Bissau",
        "iso": {
            "alpha-2": "GW",
            "alpha-3": "GNB",
            "numeric": "624"
        },
        "phone": "+245",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg",
        "phoneLength": 9
    },
    {
        "name": "Guyana",
        "iso": {
            "alpha-2": "GY",
            "alpha-3": "GUY",
            "numeric": "328"
        },
        "phone": "+592",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg",
        "phoneLength": 7
    },
    {
        "name": "Hong Kong",
        "iso": {
            "alpha-2": "HK",
            "alpha-3": "HKG",
            "numeric": "344"
        },
        "phone": "+852",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg",
        "phoneLength": 8
    },
    {
        "phoneLength": 10
    },
    {
        "name": "Honduras",
        "iso": {
            "alpha-2": "HN",
            "alpha-3": "HND",
            "numeric": "340"
        },
        "phone": "+504",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg",
        "phoneLength": 8
    },
    {
        "name": "Croatia",
        "iso": {
            "alpha-2": "HR",
            "alpha-3": "HRV",
            "numeric": "191"
        },
        "phone": "+385",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg",
        "phoneLength": 9
    },
    {
        "name": "Haiti",
        "iso": {
            "alpha-2": "HT",
            "alpha-3": "HTI",
            "numeric": "332"
        },
        "phone": "+509",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg",
        "phoneLength": 8
    },
    {
        "name": "Hungary",
        "iso": {
            "alpha-2": "HU",
            "alpha-3": "HUN",
            "numeric": "348"
        },
        "phone": "+36",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg",
        "phoneLength": 9
    },
    {
        "name": "Indonesia",
        "iso": {
            "alpha-2": "ID",
            "alpha-3": "IDN",
            "numeric": "360"
        },
        "phone": "+62",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg",
        "phoneLength": 11
    },
    {
        "name": "Ireland",
        "iso": {
            "alpha-2": "IE",
            "alpha-3": "IRL",
            "numeric": "372"
        },
        "phone": "+353",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg",
        "phoneLength": 9
    },
    {
        "name": "Israel",
        "iso": {
            "alpha-2": "IL",
            "alpha-3": "ISR",
            "numeric": "376"
        },
        "phone": "+972",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg",
        "phoneLength": 9
    },
    {
        "name": "Isle of Man",
        "iso": {
            "alpha-2": "IM",
            "alpha-3": "IMN",
            "numeric": "833"
        },
        "phone": "+44-1624",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg",
        "phoneLength": 10
    },
    {
        "name": "India",
        "iso": {
            "alpha-2": "IN",
            "alpha-3": "IND",
            "numeric": "356"
        },
        "phone": "+91",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
        "phoneLength": 10
    },
    {
        "name": "British Indian Ocean Territory",
        "iso": {
            "alpha-2": "IO",
            "alpha-3": "IOT",
            "numeric": "086"
        },
        "phone": "+246",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg",
        "phoneLength": 7
    },
    {
        "name": "Iraq",
        "iso": {
            "alpha-2": "IQ",
            "alpha-3": "IRQ",
            "numeric": "368"
        },
        "phone": "+964",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg",
        "phoneLength": 10
    },
    {
        "name": "Iran, Islamic Republic of",
        "iso": {
            "alpha-2": "IR",
            "alpha-3": "IRN",
            "numeric": "364"
        },
        "phone": "+98",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg",
        "phoneLength": 11
    },
    {
        "name": "Iceland",
        "iso": {
            "alpha-2": "IS",
            "alpha-3": "ISL",
            "numeric": "352"
        },
        "phone": "+354",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg",
        "phoneLength": 7
    },
    {
        "name": "Italy",
        "iso": {
            "alpha-2": "IT",
            "alpha-3": "ITA",
            "numeric": "380"
        },
        "phone": "+39",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg",
        "phoneLength": 10
    },
    {
        "name": "Jersey",
        "iso": {
            "alpha-2": "JE",
            "alpha-3": "JEY",
            "numeric": "832"
        },
        "phone": "+44-1534",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg",
        "phoneLength": 10
    },
    {
        "name": "Jamaica",
        "iso": {
            "alpha-2": "JM",
            "alpha-3": "JAM",
            "numeric": "388"
        },
        "phone": "+1-876",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg",
        "phoneLength": 10
    },
    {
        "name": "Jordan",
        "iso": {
            "alpha-2": "JO",
            "alpha-3": "JOR",
            "numeric": "400"
        },
        "phone": "+962",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg",
        "phoneLength": [
            8,
            9
        ]
    },
    {
        "name": "Japan",
        "iso": {
            "alpha-2": "JP",
            "alpha-3": "JPN",
            "numeric": "392"
        },
        "phone": "+81",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg"
    },
    {
        "name": "Kenya",
        "iso": {
            "alpha-2": "KE",
            "alpha-3": "KEN",
            "numeric": "404"
        },
        "phone": "+254",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg",
        "phoneLength": 10
    },
    {
        "name": "Kyrgyzstan",
        "iso": {
            "alpha-2": "KG",
            "alpha-3": "KGZ",
            "numeric": "417"
        },
        "phone": "+996",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg",
        "phoneLength": 9
    },
    {
        "name": "Cambodia",
        "iso": {
            "alpha-2": "KH",
            "alpha-3": "KHM",
            "numeric": "116"
        },
        "phone": "+855",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg",
        "phoneLength": 9
    },
    {
        "name": "Kiribati",
        "iso": {
            "alpha-2": "KI",
            "alpha-3": "KIR",
            "numeric": "296"
        },
        "phone": "+686",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg",
        "phoneLength": 8
    },
    {
        "name": "Comoros",
        "iso": {
            "alpha-2": "KM",
            "alpha-3": "COM",
            "numeric": "174"
        },
        "phone": "+269",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg",
        "phoneLength": 7
    },
    {
        "name": "Saint Kitts and Nevis",
        "iso": {
            "alpha-2": "KN",
            "alpha-3": "KNA",
            "numeric": "659"
        },
        "phone": "+1-869",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg",
        "phoneLength": 10
    },
    {
        "name": "Korea, Democratic People's Republic of",
        "iso": {
            "alpha-2": "KP",
            "alpha-3": "PRK",
            "numeric": "408"
        },
        "phone": "+850",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg",
        "phoneLength": [
            4,
            6,
            7,
            13
        ]
    },
    {
        "name": "Korea, Republic of",
        "iso": {
            "alpha-2": "KR",
            "alpha-3": "KOR",
            "numeric": "410"
        },
        "phone": "+82",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg",
        "phoneLength": [
            7,
            8
        ]
    },
    {
        "name": "Kuwait",
        "iso": {
            "alpha-2": "KW",
            "alpha-3": "KWT",
            "numeric": "414"
        },
        "phone": "+965",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg",
        "phoneLength": 8
    },
    {
        "name": "Cayman Islands",
        "iso": {
            "alpha-2": "KY",
            "alpha-3": "CYM",
            "numeric": "136"
        },
        "phone": "+1-345",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg",
        "phoneLength": 7
    },
    {
        "name": "Kazakhstan",
        "iso": {
            "alpha-2": "KZ",
            "alpha-3": "KAZ",
            "numeric": "398"
        },
        "phone": "+7",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg",
        "phoneLength": 10
    },
    {
        "name": "Lao People's Democratic Republic",
        "iso": {
            "alpha-2": "LA",
            "alpha-3": "LAO",
            "numeric": "418"
        },
        "phone": "+856",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg",
        "phoneLength": [
            8,
            9
        ]
    },
    {
        "name": "Lebanon",
        "iso": {
            "alpha-2": "LB",
            "alpha-3": "LBN",
            "numeric": "422"
        },
        "phone": "+961",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg",
        "phoneLength": [
            7,
            8
        ]
    },
    {
        "name": "Saint Lucia",
        "iso": {
            "alpha-2": "LC",
            "alpha-3": "LCA",
            "numeric": "662"
        },
        "phone": "+1-758",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg",
        "phoneLength": 7
    },
    {
        "name": "Liechtenstein",
        "iso": {
            "alpha-2": "LI",
            "alpha-3": "LIE",
            "numeric": "438"
        },
        "phone": "+423",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
        "phoneLength": 7
    },
    {
        "name": "Sri Lanka",
        "iso": {
            "alpha-2": "LK",
            "alpha-3": "LKA",
            "numeric": "144"
        },
        "phone": "+94",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg",
        "phoneLength": 7
    },
    {
        "name": "Liberia",
        "iso": {
            "alpha-2": "LR",
            "alpha-3": "LBR",
            "numeric": "430"
        },
        "phone": "+231",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg",
        "phoneLength": [
            8,
            9
        ]
    },
    {
        "name": "Lesotho",
        "iso": {
            "alpha-2": "LS",
            "alpha-3": "LSO",
            "numeric": "426"
        },
        "phone": "+266",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg",
        "phoneLength": 8
    },
    {
        "name": "Lithuania",
        "iso": {
            "alpha-2": "LT",
            "alpha-3": "LTU",
            "numeric": "440"
        },
        "phone": "+370",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg",
        "phoneLength": 8
    },
    {
        "name": "Luxembourg",
        "iso": {
            "alpha-2": "LU",
            "alpha-3": "LUX",
            "numeric": "442"
        },
        "phone": "+352",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg",
        "phoneLength": 9
    },
    {
        "name": "Latvia",
        "iso": {
            "alpha-2": "LV",
            "alpha-3": "LVA",
            "numeric": "428"
        },
        "phone": "+371",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg",
        "phoneLength": 8
    },
    {
        "name": "Libya",
        "iso": {
            "alpha-2": "LY",
            "alpha-3": "LBY",
            "numeric": "434"
        },
        "phone": "+218",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg",
        "phoneLength": 10
    },
    {
        "name": "Morocco",
        "iso": {
            "alpha-2": "MA",
            "alpha-3": "MAR",
            "numeric": "504"
        },
        "phone": "+212",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg",
        "phoneLength": 9
    },
    {
        "name": "Monaco",
        "iso": {
            "alpha-2": "MC",
            "alpha-3": "MCO",
            "numeric": "492"
        },
        "phone": "+377",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg",
        "phoneLength": 8
    },
    {
        "name": "Moldova, Republic of",
        "iso": {
            "alpha-2": "MD",
            "alpha-3": "MDA",
            "numeric": "498"
        },
        "phone": "+373",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg",
        "phoneLength": 8
    },
    {
        "name": "Montenegro",
        "iso": {
            "alpha-2": "ME",
            "alpha-3": "MNE",
            "numeric": "499"
        },
        "phone": "+382",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg",
        "phoneLength": 8
    },
    {
        "name": "Saint Martin (French part)",
        "iso": {
            "alpha-2": "MF",
            "alpha-3": "MAF",
            "numeric": "663"
        },
        "phone": "+590",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg",
        "phoneLength": 6
    },
    {
        "name": "Madagascar",
        "iso": {
            "alpha-2": "MG",
            "alpha-3": "MDG",
            "numeric": "450"
        },
        "phone": "+261",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg",
        "phoneLength": 7
    },
    {
        "name": "Marshall Islands",
        "iso": {
            "alpha-2": "MH",
            "alpha-3": "MHL",
            "numeric": "584"
        },
        "phone": "+692",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg",
        "phoneLength": 7
    },
    {
        "name": "Macedonia, the Former Yugoslav Republic of",
        "iso": {
            "alpha-2": "MK",
            "alpha-3": "MKD",
            "numeric": "807"
        },
        "phone": "+389",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg",
        "phoneLength": 8
    },
    {
        "name": "Mali",
        "iso": {
            "alpha-2": "ML",
            "alpha-3": "MLI",
            "numeric": "466"
        },
        "phone": "+223",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg",
        "phoneLength": 8
    },
    {
        "name": "Myanmar",
        "iso": {
            "alpha-2": "MM",
            "alpha-3": "MMR",
            "numeric": "104"
        },
        "phone": "+95",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg"
    },
    {
        "name": "Mongolia",
        "iso": {
            "alpha-2": "MN",
            "alpha-3": "MNG",
            "numeric": "496"
        },
        "phone": "+976",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg",
        "phoneLength": 8
    },
    {
        "name": "Macao",
        "iso": {
            "alpha-2": "MO",
            "alpha-3": "MAC",
            "numeric": "446"
        },
        "phone": "+853",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg",
        "phoneLength": 8
    },
    {
        "name": "Northern Mariana Islands",
        "iso": {
            "alpha-2": "MP",
            "alpha-3": "MNP",
            "numeric": "580"
        },
        "phone": "+1-670",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg",
        "phoneLength": 7
    },
    {
        "name": "Martinique",
        "iso": {
            "alpha-2": "MQ",
            "alpha-3": "MTQ",
            "numeric": "474"
        },
        "phone": "+596",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg",
        "phoneLength": 9
    },
    {
        "name": "Mauritania",
        "iso": {
            "alpha-2": "MR",
            "alpha-3": "MRT",
            "numeric": "478"
        },
        "phone": "+222",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg",
        "phoneLength": 8
    },
    {
        "name": "Montserrat",
        "iso": {
            "alpha-2": "MS",
            "alpha-3": "MSR",
            "numeric": "500"
        },
        "phone": "+1-664",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg",
        "phoneLength": 10
    },
    {
        "name": "Malta",
        "iso": {
            "alpha-2": "MT",
            "alpha-3": "MLT",
            "numeric": "470"
        },
        "phone": "+356",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg",
        "phoneLength": 8
    },
    {
        "name": "Mauritius",
        "iso": {
            "alpha-2": "MU",
            "alpha-3": "MUS",
            "numeric": "480"
        },
        "phone": "+230",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg",
        "phoneLength": 8
    },
    {
        "name": "Maldives",
        "iso": {
            "alpha-2": "MV",
            "alpha-3": "MDV",
            "numeric": "462"
        },
        "phone": "+960",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg",
        "phoneLength": 7
    },
    {
        "name": "Malawi",
        "iso": {
            "alpha-2": "MW",
            "alpha-3": "MWI",
            "numeric": "454"
        },
        "phone": "+265",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg",
        "phoneLength": [
            7,
            8,
            9
        ]
    },
    {
        "name": "Mexico",
        "iso": {
            "alpha-2": "MX",
            "alpha-3": "MEX",
            "numeric": "484"
        },
        "phone": "+52",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg",
        "phoneLength": 10
    },
    {
        "name": "Malaysia",
        "iso": {
            "alpha-2": "MY",
            "alpha-3": "MYS",
            "numeric": "458"
        },
        "phone": "+60",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg",
        "phoneLength": 7
    },
    {
        "name": "Mozambique",
        "iso": {
            "alpha-2": "MZ",
            "alpha-3": "MOZ",
            "numeric": "508"
        },
        "phone": "+258",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg",
        "phoneLength": 12
    },
    {
        "name": "Namibia",
        "iso": {
            "alpha-2": "NA",
            "alpha-3": "NAM",
            "numeric": "516"
        },
        "phone": "+264",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg",
        "phoneLength": 7
    },
    {
        "name": "New Caledonia",
        "iso": {
            "alpha-2": "NC",
            "alpha-3": "NCL",
            "numeric": "540"
        },
        "phone": "+687",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg",
        "phoneLength": 6
    },
    {
        "name": "Niger",
        "iso": {
            "alpha-2": "NE",
            "alpha-3": "NER",
            "numeric": "562"
        },
        "phone": "+227",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg",
        "phoneLength": 8
    },
    {
        "name": "Norfolk Island",
        "iso": {
            "alpha-2": "NF",
            "alpha-3": "NFK",
            "numeric": "574"
        },
        "phone": "+672",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg",
        "phoneLength": 6
    },
    {
        "name": "Nigeria",
        "iso": {
            "alpha-2": "NG",
            "alpha-3": "NGA",
            "numeric": "566"
        },
        "phone": "+234",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg",
        "phoneLength": 8
    },
    {
        "name": "Nicaragua",
        "iso": {
            "alpha-2": "NI",
            "alpha-3": "NIC",
            "numeric": "558"
        },
        "phone": "+505",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg",
        "phoneLength": 8
    },
    {
        "name": "Netherlands",
        "iso": {
            "alpha-2": "NL",
            "alpha-3": "NLD",
            "numeric": "528"
        },
        "phone": "+31",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg",
        "phoneLength": 9
    },
    {
        "name": "Norway",
        "iso": {
            "alpha-2": "NO",
            "alpha-3": "NOR",
            "numeric": "578"
        },
        "phone": "+47",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg",
        "phoneLength": 8
    },
    {
        "name": "Nepal",
        "iso": {
            "alpha-2": "NP",
            "alpha-3": "NPL",
            "numeric": "524"
        },
        "phone": "+977",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg",
        "phoneLength": 10
    },
    {
        "name": "Nauru",
        "iso": {
            "alpha-2": "NR",
            "alpha-3": "NRU",
            "numeric": "520"
        },
        "phone": "+674",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg",
        "phoneLength": 7
    },
    {
        "name": "Niue",
        "iso": {
            "alpha-2": "NU",
            "alpha-3": "NIU",
            "numeric": "570"
        },
        "phone": "+683",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg",
        "phoneLength": 4
    },
    {
        "name": "New Zealand",
        "iso": {
            "alpha-2": "NZ",
            "alpha-3": "NZL",
            "numeric": "554"
        },
        "phone": "+64",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg",
        "phoneLength": [
            8,
            9
        ]
    },
    {
        "name": "Oman",
        "iso": {
            "alpha-2": "OM",
            "alpha-3": "OMN",
            "numeric": "512"
        },
        "phone": "+968",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg",
        "phoneLength": 8
    },
    {
        "name": "Panama",
        "iso": {
            "alpha-2": "PA",
            "alpha-3": "PAN",
            "numeric": "591"
        },
        "phone": "+507",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg",
        "phoneLength": 8
    },
    {
        "name": "Peru",
        "iso": {
            "alpha-2": "PE",
            "alpha-3": "PER",
            "numeric": "604"
        },
        "phone": "+51",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg",
        "phoneLength": 9
    },
    {
        "name": "French Polynesia",
        "iso": {
            "alpha-2": "PF",
            "alpha-3": "PYF",
            "numeric": "258"
        },
        "phone": "+689",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg",
        "phoneLength": 8
    },
    {
        "name": "Papua New Guinea",
        "iso": {
            "alpha-2": "PG",
            "alpha-3": "PNG",
            "numeric": "598"
        },
        "phone": "+675",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg",
        "phoneLength": 8
    },
    {
        "name": "Philippines",
        "iso": {
            "alpha-2": "PH",
            "alpha-3": "PHL",
            "numeric": "608"
        },
        "phone": "+63",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg",
        "phoneLength": 10
    },
    {
        "name": "Pakistan",
        "iso": {
            "alpha-2": "PK",
            "alpha-3": "PAK",
            "numeric": "586"
        },
        "phone": "+92",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg",
        "phoneLength": 10
    },
    {
        "name": "Poland",
        "iso": {
            "alpha-2": "PL",
            "alpha-3": "POL",
            "numeric": "616"
        },
        "phone": "+48",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg",
        "phoneLength": 9
    },
    {
        "name": "Saint Pierre and Miquelon",
        "iso": {
            "alpha-2": "PM",
            "alpha-3": "SPM",
            "numeric": "666"
        },
        "phone": "+508",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg",
        "phoneLength": 6
    },
    {
        "name": "Pitcairn",
        "iso": {
            "alpha-2": "PN",
            "alpha-3": "PCN",
            "numeric": "612"
        },
        "phone": "+870",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg",
        "phoneLength": 9
    },
    {
        "name": "Puerto Rico",
        "iso": {
            "alpha-2": "PR",
            "alpha-3": "PRI",
            "numeric": "630"
        },
        "phone": "+1-787",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg",
        "phoneLength": 10
    },
    {
        "name": "Palestine, State of",
        "iso": {
            "alpha-2": "PS",
            "alpha-3": "PSE",
            "numeric": "275"
        },
        "phone": "+970",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg",
        "phoneLength": 9
    },
    {
        "name": "Portugal",
        "iso": {
            "alpha-2": "PT",
            "alpha-3": "PRT",
            "numeric": "620"
        },
        "phone": "+351",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg",
        "phoneLength": 9
    },
    {
        "name": "Palau",
        "iso": {
            "alpha-2": "PW",
            "alpha-3": "PLW",
            "numeric": "585"
        },
        "phone": "+680",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg",
        "phoneLength": 7
    },
    {
        "name": "Paraguay",
        "iso": {
            "alpha-2": "PY",
            "alpha-3": "PRY",
            "numeric": "600"
        },
        "phone": "+595",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg",
        "phoneLength": 9
    },
    {
        "name": "Qatar",
        "iso": {
            "alpha-2": "QA",
            "alpha-3": "QAT",
            "numeric": "634"
        },
        "phone": "+974",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg",
        "phoneLength": 8
    },
    {
        "name": "R\u00e9union",
        "iso": {
            "alpha-2": "RE",
            "alpha-3": "REU",
            "numeric": "638"
        },
        "phone": "+262",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg",
        "phoneLength": 10
    },
    {
        "name": "Romania",
        "iso": {
            "alpha-2": "RO",
            "alpha-3": "ROU",
            "numeric": "642"
        },
        "phone": "+40",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg",
        "phoneLength": 10
    },
    {
        "name": "Serbia",
        "iso": {
            "alpha-2": "RS",
            "alpha-3": "SRB",
            "numeric": "688"
        },
        "phone": "+381",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg",
        "phoneLength": 9
    },
    {
        "name": "Russian Federation",
        "iso": {
            "alpha-2": "RU",
            "alpha-3": "RUS",
            "numeric": "643"
        },
        "phone": "+7",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg",
        "phoneLength": 10
    },
    {
        "name": "Rwanda",
        "iso": {
            "alpha-2": "RW",
            "alpha-3": "RWA",
            "numeric": "646"
        },
        "phone": "+250",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg",
        "phoneLength": 9
    },
    {
        "name": "Saudi Arabia",
        "iso": {
            "alpha-2": "SA",
            "alpha-3": "SAU",
            "numeric": "682"
        },
        "phone": "+966",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg",
        "phoneLength": 9
    },
    {
        "name": "Solomon Islands",
        "iso": {
            "alpha-2": "SB",
            "alpha-3": "SLB",
            "numeric": "090"
        },
        "phone": "+677",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg",
        "phoneLength": 7
    },
    {
        "name": "Seychelles",
        "iso": {
            "alpha-2": "SC",
            "alpha-3": "SYC",
            "numeric": "690"
        },
        "phone": "+248",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg",
        "phoneLength": 7
    },
    {
        "name": "Sudan",
        "iso": {
            "alpha-2": "SD",
            "alpha-3": "SDN",
            "numeric": "729"
        },
        "phone": "+249",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg",
        "phoneLength": 7
    },
    {
        "name": "Sweden",
        "iso": {
            "alpha-2": "SE",
            "alpha-3": "SWE",
            "numeric": "752"
        },
        "phone": "+46",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg",
        "phoneLength": 7
    },
    {
        "name": "Singapore",
        "iso": {
            "alpha-2": "SG",
            "alpha-3": "SGP",
            "numeric": "702"
        },
        "phone": "+65",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg",
        "phoneLength": 8
    },
    {
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "iso": {
            "alpha-2": "SH",
            "alpha-3": "SHN",
            "numeric": "654"
        },
        "phone": "+290",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg",
        "phoneLength": 4
    },
    {
        "name": "Slovenia",
        "iso": {
            "alpha-2": "SI",
            "alpha-3": "SVN",
            "numeric": "705"
        },
        "phone": "+386",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg",
        "phoneLength": 9
    },
    {
        "name": "Svalbard and Jan Mayen",
        "iso": {
            "alpha-2": "SJ",
            "alpha-3": "SJM",
            "numeric": "744"
        },
        "phone": "+47",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg",
        "phoneLength": 8
    },
    {
        "name": "Slovakia",
        "iso": {
            "alpha-2": "SK",
            "alpha-3": "SVK",
            "numeric": "703"
        },
        "phone": "+421",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg",
        "phoneLength": 9
    },
    {
        "name": "Sierra Leone",
        "iso": {
            "alpha-2": "SL",
            "alpha-3": "SLE",
            "numeric": "694"
        },
        "phone": "+232",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg",
        "phoneLength": 8
    },
    {
        "name": "San Marino",
        "iso": {
            "alpha-2": "SM",
            "alpha-3": "SMR",
            "numeric": "674"
        },
        "phone": "+378",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg",
        "phoneLength": 10
    },
    {
        "name": "Senegal",
        "iso": {
            "alpha-2": "SN",
            "alpha-3": "SEN",
            "numeric": "686"
        },
        "phone": "+221",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg",
        "phoneLength": 9
    },
    {
        "name": "Somalia",
        "iso": {
            "alpha-2": "SO",
            "alpha-3": "SOM",
            "numeric": "706"
        },
        "phone": "+252",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg",
        "phoneLength": [
            8,
            9
        ]
    },
    {
        "name": "Suriname",
        "iso": {
            "alpha-2": "SR",
            "alpha-3": "SUR",
            "numeric": "740"
        },
        "phone": "+597",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg",
        "phoneLength": [
            6,
            7
        ]
    },
    {
        "name": "South Sudan",
        "iso": {
            "alpha-2": "SS",
            "alpha-3": "SSD",
            "numeric": "728"
        },
        "phone": "+211",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg",
        "phoneLength": 7
    },
    {
        "name": "Sao Tome and Principe",
        "iso": {
            "alpha-2": "ST",
            "alpha-3": "STP",
            "numeric": "678"
        },
        "phone": "+239",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg",
        "phoneLength": 7
    },
    {
        "name": "El Salvador",
        "iso": {
            "alpha-2": "SV",
            "alpha-3": "SLV",
            "numeric": "222"
        },
        "phone": "+503",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg",
        "phoneLength": 8
    },
    {
        "name": "Sint Maarten (Dutch part)",
        "iso": {
            "alpha-2": "SX",
            "alpha-3": "SXM",
            "numeric": "534"
        },
        "phone": "+599",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SX.svg",
        "phoneLength": 10
    },
    {
        "name": "Syrian Arab Republic",
        "iso": {
            "alpha-2": "SY",
            "alpha-3": "SYR",
            "numeric": "760"
        },
        "phone": "+963",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg",
        "phoneLength": 7
    },
    {
        "name": "Swaziland",
        "iso": {
            "alpha-2": "SZ",
            "alpha-3": "SWZ",
            "numeric": "748"
        },
        "phone": "+268",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg",
        "phoneLength": 8
    },
    {
        "name": "Turks and Caicos Islands",
        "iso": {
            "alpha-2": "TC",
            "alpha-3": "TCA",
            "numeric": "796"
        },
        "phone": "+1-649",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg",
        "phoneLength": 10
    },
    {
        "name": "Chad",
        "iso": {
            "alpha-2": "TD",
            "alpha-3": "TCD",
            "numeric": "148"
        },
        "phone": "+235",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg",
        "phoneLength": 6
    },
    {
        "name": "French Southern Territories",
        "iso": {
            "alpha-2": "TF",
            "alpha-3": "ATF",
            "numeric": "260"
        },
        "phone": "+",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg",
        "phoneLength": 10
    },
    {
        "name": "Togo",
        "iso": {
            "alpha-2": "TG",
            "alpha-3": "TGO",
            "numeric": "768"
        },
        "phone": "+228",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg",
        "phoneLength": 8
    },
    {
        "name": "Thailand",
        "iso": {
            "alpha-2": "TH",
            "alpha-3": "THA",
            "numeric": "764"
        },
        "phone": "+66",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg",
        "phoneLength": 9
    },
    {
        "name": "Tajikistan",
        "iso": {
            "alpha-2": "TJ",
            "alpha-3": "TJK",
            "numeric": "762"
        },
        "phone": "+992",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg",
        "phoneLength": 9
    },
    {
        "name": "Tokelau",
        "iso": {
            "alpha-2": "TK",
            "alpha-3": "TKL",
            "numeric": "772"
        },
        "phone": "+690",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg",
        "phoneLength": 5
    },
    {
        "name": "Timor-Leste",
        "iso": {
            "alpha-2": "TL",
            "alpha-3": "TLS",
            "numeric": "626"
        },
        "phone": "+670",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg",
        "phoneLength": 7
    },
    {
        "name": "Turkmenistan",
        "iso": {
            "alpha-2": "TM",
            "alpha-3": "TKM",
            "numeric": "795"
        },
        "phone": "+993",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg",
        "phoneLength": 8
    },
    {
        "name": "Tunisia",
        "iso": {
            "alpha-2": "TN",
            "alpha-3": "TUN",
            "numeric": "788"
        },
        "phone": "+216",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg",
        "phoneLength": 8
    },
    {
        "name": "Tonga",
        "iso": {
            "alpha-2": "TO",
            "alpha-3": "TON",
            "numeric": "776"
        },
        "phone": "+676",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg",
        "phoneLength": 5
    },
    {
        "name": "Turkey",
        "iso": {
            "alpha-2": "TR",
            "alpha-3": "TUR",
            "numeric": "792"
        },
        "phone": "+90",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg",
        "phoneLength": 11
    },
    {
        "name": "Trinidad and Tobago",
        "iso": {
            "alpha-2": "TT",
            "alpha-3": "TTO",
            "numeric": "780"
        },
        "phone": "+1-868",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg",
        "phoneLength": 7
    },
    {
        "name": "Tuvalu",
        "iso": {
            "alpha-2": "TV",
            "alpha-3": "TUV",
            "numeric": "798"
        },
        "phone": "+688",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg",
        "phoneLength": 5
    },
    {
        "name": "Taiwan, Province of China",
        "iso": {
            "alpha-2": "TW",
            "alpha-3": "TWN",
            "numeric": "158"
        },
        "phone": "+886",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg",
        "phoneLength": 9
    },
    {
        "name": "Tanzania, United Republic of",
        "iso": {
            "alpha-2": "TZ",
            "alpha-3": "TZA",
            "numeric": "834"
        },
        "phone": "+255",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg",
        "phoneLength": 7
    },
    {
        "name": "Ukraine",
        "iso": {
            "alpha-2": "UA",
            "alpha-3": "UKR",
            "numeric": "804"
        },
        "phone": "+380",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg",
        "phoneLength": 9
    },
    {
        "name": "Uganda",
        "iso": {
            "alpha-2": "UG",
            "alpha-3": "UGA",
            "numeric": "800"
        },
        "phone": "+256",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg",
        "phoneLength": 7
    },
    {
        "name": "United States",
        "iso": {
            "alpha-2": "US",
            "alpha-3": "USA",
            "numeric": "840"
        },
        "phone": "+1",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg",
        "phoneLength": 10
    },
    {
        "name": "Uruguay",
        "iso": {
            "alpha-2": "UY",
            "alpha-3": "URY",
            "numeric": "858"
        },
        "phone": "+598",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg",
        "phoneLength": 8
    },
    {
        "name": "Uzbekistan",
        "iso": {
            "alpha-2": "UZ",
            "alpha-3": "UZB",
            "numeric": "860"
        },
        "phone": "+998",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg",
        "phoneLength": 9
    },
    {
        "name": "Holy See (Vatican City State)",
        "iso": {
            "alpha-2": "VA",
            "alpha-3": "VAT",
            "numeric": "336"
        },
        "phone": "+379",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg",
        "phoneLength": 10
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "iso": {
            "alpha-2": "VC",
            "alpha-3": "VCT",
            "numeric": "670"
        },
        "phone": "+1-784",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg",
        "phoneLength": 7
    },
    {
        "name": "Venezuela, Bolivarian Republic of",
        "iso": {
            "alpha-2": "VE",
            "alpha-3": "VEN",
            "numeric": "862"
        },
        "phone": "+58",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg",
        "phoneLength": 7
    },
    {
        "name": "Virgin Islands, British",
        "iso": {
            "alpha-2": "VG",
            "alpha-3": "VGB",
            "numeric": "092"
        },
        "phone": "+1-284",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg",
        "phoneLength": 7
    },
    {
        "name": "Virgin Islands, U.S.",
        "iso": {
            "alpha-2": "VI",
            "alpha-3": "VIR",
            "numeric": "850"
        },
        "phone": "+1-340",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg",
        "phoneLength": 10
    },
    {
        "name": "Viet Nam",
        "iso": {
            "alpha-2": "VN",
            "alpha-3": "VNM",
            "numeric": "704"
        },
        "phone": "+84",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg",
        "phoneLength": 9
    },
    {
        "name": "Vanuatu",
        "iso": {
            "alpha-2": "VU",
            "alpha-3": "VUT",
            "numeric": "548"
        },
        "phone": "+678",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg",
        "phoneLength": 5
    },
    {
        "name": "Wallis and Futuna",
        "iso": {
            "alpha-2": "WF",
            "alpha-3": "WLF",
            "numeric": "876"
        },
        "phone": "+681",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg",
        "phoneLength": 6
    },
    {
        "name": "Samoa",
        "iso": {
            "alpha-2": "WS",
            "alpha-3": "WSM",
            "numeric": "882"
        },
        "phone": "+685",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg",
        "phoneLength": [
            5,
            6,
            7
        ]
    },
    {
        "phoneLength": 8
    },
    {
        "name": "Yemen",
        "iso": {
            "alpha-2": "YE",
            "alpha-3": "YEM",
            "numeric": "887"
        },
        "phone": "+967",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg",
        "phoneLength": 9
    },
    {
        "name": "Mayotte",
        "iso": {
            "alpha-2": "YT",
            "alpha-3": "MYT",
            "numeric": "175"
        },
        "phone": "+262",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg",
        "phoneLength": 9
    },
    {
        "name": "South Africa",
        "iso": {
            "alpha-2": "ZA",
            "alpha-3": "ZAF",
            "numeric": "710"
        },
        "phone": "+27",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg",
        "phoneLength": 9
    },
    {
        "name": "Zambia",
        "iso": {
            "alpha-2": "ZM",
            "alpha-3": "ZMB",
            "numeric": "894"
        },
        "phone": "+260",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg",
        "phoneLength": 9
    },
    {
        "name": "Zimbabwe",
        "iso": {
            "alpha-2": "ZW",
            "alpha-3": "ZWE",
            "numeric": "716"
        },
        "phone": "+263",
        "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg",
        "phoneLength": 9
    }
];